import React from "react";
import TextLoop from "react-text-loop";
import styled from 'styled-components';

import underline from "./../assets/png/underline.png"

// Styled Components
const StyledBreak1 = styled.br`
@media only screen and (max-width: 680px) {
    display: none;
}
`;
const StyledBreak2 = styled.br`
@media only screen and (min-width: 680px) {
    display: none;
}
`;
const StyledIntroContainer = styled.div`
& {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    height: 100vh;
}
@media only screen and (max-width: 680px) {
    flex-direction: column;
    margin-right: 25px
    margin-left: 25px;
}
`;
const StyledIntroTextContainer = styled.div`
& {
    text-align: left;
    display: inline-block;
    width: 520px;
}
@media only screen and (max-width: 680px) {
    margin-bottom: 32px;
    text-align: center;
    width: auto
}
`;
const StyledProfileContainer = styled.div`
& {
    position: relative;
    display: inline-block;
    max-width: 45%;
    margin-left: 60px;
}
@media only screen and (max-width: 680px) {
    margin: 0;
}
`;
const StyledProfilePattern = styled.img`
& {
    position: absolute;
    display: inline;
    width: 230px;
    z-index: -1;
    left: -90px;    
    bottom: 60px;
}
@media only screen and (max-width: 680px) {
    width: 120px;
    left: -50px; 
    bottom: 20px;
}
`;
const StyledProfilePicture = styled.img`
& {
    display: inline;
    border-radius: 50%;
    width: 370px;
}
@media only screen and (max-width: 680px) {
    width: 200px;
}
`;
const StyledName = styled.span`
& {
    color: ${props => props.themecolor.primaryColor}
}
`;
const StyledIntroH2 = styled.h2`
@media only screen and (max-width: 680px) {
    font-size: 18px;
}
`;
const StyledIntroH1 = styled.h1`
@media only screen and (max-width: 680px) {
    font-size: 20px;
}
`
const StyledUnderline = styled.img`
position: absolute;
@media only screen and (min-width: 680px) {
    width: 100px;
    margin-left: 200px;
    margin-top: -18px;
    padding-top: 0;
    width: 120px;
}
@media only screen and (max-width: 680px) {
    width: 16px;
    height: 16px;
    margin-left: -52px;
    margin-top: -8px;
    padding-top: 0;
    width: 120px;
}
`;
function Introduction({ person }) {
    return (
        <StyledIntroContainer>
            <StyledIntroTextContainer>
                <StyledIntroH2>Hello!</StyledIntroH2>
                <br />
                <StyledIntroH1 style={{ margin: '0' }}>I'm <StyledName themecolor={person.themeColor}>{person.firstName}</StyledName>,</StyledIntroH1>
                <StyledIntroH1>{person.areaOfInterest}
                    <StyledBreak1 />{" and "}<StyledBreak2 />
                    <TextLoop interval={2200} springConfig={{ stiffness: 150, damping: 10 }} children={person.alterEgos} />
                </StyledIntroH1>
                <StyledUnderline src={underline} alt="underline" />
            </StyledIntroTextContainer>
            <StyledProfileContainer>
                <StyledProfilePattern src={person.profilePattern} />
                <StyledProfilePicture alt="Profile" src={person.img} />
            </StyledProfileContainer>
        </StyledIntroContainer>
    );
}

export default Introduction;